/*
 Convention: https://docs.google.com/document/d/1ePqfM41II2CNBYpTuOgjLZafRkn6vABQ5NF40JGER1E/edit
 Review Reference: https://docs.google.com/document/d/1Diu8ZwKXPOWCsH2ry8rufCYADGFcHtR4MY3k1c3Ypes/edit

 ! Review
 TODO Disbursement - change to ts
 */
import auth from 'src/utilities/auth';
import { defaultAction } from '../types';

const initialState = {
  data: {
    campaign_name: '',
    description: '',
    filename: '',
    username: auth?.user?.company_username,
    type: 'transfer',
    sms_template: '',
    campaign_create_by: auth?.user?.username,
  },
  errors: {
    campaign_name: '',
    description: '',
    filename: '',
    username: '',
    type: '',
    sms_template: '',
  },
  rules: {
    campaign_name: 'required',
    description: 'required',
    filename: 'required',
    username: 'required',
    type: 'required',
    sms_template: '',
  },
  fileHeader: [],
  fileData: [],
  loadingButton: false,
};

const bulkTransferReducer = (state = initialState, action = defaultAction) => {
  switch (action.type) {
    case 'SET_LOADING':
      return {
        ...state,
        loadingButton: action.payload,
      };
    case 'SET_FILE_DATA_ITEMS': {
      const { startIndex } = action.payload;
      const updateItems = action.payload.items;
      const fileData = state.fileData.map((item, index) => {
        if (index < startIndex || index >= updateItems.length + startIndex) {
          return item;
        }
        return updateItems[index - startIndex];
      });
      return {
        ...state,
        fileData,
      };
    }
    case 'SET_FILE':
      return {
        ...state,
        fileHeader: action.payload.fileHeader,
        fileData: action.payload.fileData,
      };
    case 'SET_DATA':
      return {
        ...state,
        data: {
          ...(state.data.data ?? state.data),
          [action.payload.name]: action.payload.value,
        },
      };
    case 'RESET_DATA':
      return initialState;
    case 'SET_ERRORS':
      return {
        ...state,
        errors: action.payload,
      };
    case 'UNSET_ERRORS':
      return {
        ...state,
        errors: initialState.errors,
      };
    default:
      return state;
  }
};

export default bulkTransferReducer;
